<div [formGroup]="formulario">
  <div class="row">
    <div class="col-12 col-md-1">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>ID</mat-label>
        <input formControlName="id" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-1">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>ID WOW.ve</mat-label>
        <input formControlName="wowveId" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Nome do Plano</mat-label>
        <input formControlName="nome" matInput required>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Segmento</mat-label>
        <mat-select formControlName="segmentoId" required>
          <mat-option *ngFor="let seg of segmentos" [value]="seg.id">{{ seg.nome }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Valor Base</mat-label>
        <input formControlName="valorBase" matInput currencyMask
          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }" required>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Taxa de Adesão</mat-label>
        <input formControlName="taxaAdesao" matInput currencyMask
          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }">
      </mat-form-field>
    </div>
    <div class="col-12 col-md-2">
      <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
        <mat-label>Situação</mat-label>
        <mat-select formControlName="situacao" required>
          <mat-option [value]="true">Ativo</mat-option>
          <mat-option [value]="false">Inativo</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <label class="plano-func__titulo">Funcionalidades</label>
      <p class="plano-func__hint" *ngIf="!formulario.value.segmentoId">
        Selecione um segmento para listar as funcionalidades.
      </p>
      <p class="plano-func__hint" *ngIf="formulario.value.segmentoId && !funcionalidades.length">
        Nenhuma funcionalidade ativa cadastrada para este segmento.
      </p>
      <div class="row border rounded p-3 m-0 plano-func__grid"
        *ngIf="formulario.value.segmentoId && funcionalidades.length">
        <div *ngFor="let func of funcionalidades" class="col-12 col-sm-6 col-md-4 col-lg-3 plano-func__item">
          <label>
            <input type="checkbox"
              [checked]="funcionalidadeSelecionada(func.id)"
              (change)="alternarFuncionalidade(func.id)">
            {{ func.descricao }}
            <span class="plano-func__valor" *ngIf="func.vendaAvulsa && func.valor">
              — {{ func.valor | currency:'BRL':'symbol':'1.2-2' }}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
